<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">综合查询:</div>
                <el-input v-model="conditionData.Multiple" size="small" placeholder="请输入"></el-input>
            </div>
            
            <div class="item">
                <div class="label">开始日期:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">结束日期:</div>
                <el-date-picker
                v-model="conditionData.EndTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">财务状态:</div>
                <el-select v-model="conditionData.financeState" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in carOutstandTermStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            
            <div class="item">
                <div class="label">是否关联案件:</div>
                <el-select v-model="conditionData.IsJoinCase" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in IsJoinCaseList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            
            <div class="item">
                <div class="label">开票公司:</div>
                <el-select v-model="conditionData.CompanyName" size="small" placeholder="请选择" filterable>
                    <el-option
                    v-for="item in organizationList"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div style="display:flex" v-if="isHandle=='1'">
                    <el-button type="success" icon="el-icon-download" size="small" @click="downloadExcel(2)">下载立项模板</el-button>
                    <el-upload
                        :action="uploadUrl"
                        Multiple
                        :show-file-list="false"
                        :http-request="addBatch"
                        >
                        <el-button type="primary" icon="el-icon-upload" size="small" style="margin:0 10px">批量新增</el-button>
                    </el-upload>
                    <!-- <el-upload
                        :action="uploadUrl"
                        Multiple
                        :show-file-list="false"
                        :http-request="UpdateBatch"
                        >
                        <el-button type="primary" icon="el-icon-upload" size="small" style="margin-right:10px">批量修改</el-button>
                    </el-upload> -->
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="showAddDialog">新建</el-button>

                    <el-button type="success" icon="el-icon-download" size="small" @click="downloadList()">导出立项</el-button>


                    <el-button type="success" icon="el-icon-download" size="small" @click="downloadExcel(1)">下载关联案件模板</el-button>

                    <el-upload
                        :action="uploadUrl"
                        Multiple
                        :show-file-list="false"
                        :http-request="showRelevanceUpload"
                        >
                        <el-button type="success" icon="el-icon-more" size="small" style="margin:0 10px">关联案件</el-button>
                    </el-upload>

                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                
                <el-table-column
                type="selection"
                align="center"
                width="55">
                </el-table-column>
                <el-table-column
                prop="standProjectId"
                width="120"
                label="立项ID"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="立项名称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceNo"
                label="发票号"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceCode"
                label="发票编码"
                align="center"
                width="200"
                
                >
                <template slot-scope="scope">
                    <span class="push">
                        {{scope.row.invoiceCode}}
                        <el-button type="danger" icon="el-icon-upload" size="mini" @click="pushKinDie(scope.row)" v-if="!scope.row.isPushKinDie&&isPush=='1'" plain>复推</el-button>
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="invoicePrice"
                label="发票金额"
                align="center"
                width="120"
                
                >
                </el-table-column>
                <el-table-column
                prop="actualPrice"
                label="实际收金额"
                align="center"
                width="120"
                >
                </el-table-column>
                <el-table-column
                prop="company"
                label="公司"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="companyCodeName"
                label="委托公司全称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="organization"
                label="开票公司"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="状态"
                align="center"
                width="200"
                
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==6">未完成未开票</span>
                    <span v-if="scope.row.financeState==9">已完成未开票</span>
                    <span v-if="scope.row.financeState==1">已开票未回款</span>
                    <span v-if="scope.row.financeState==2">已开票部分回款</span>
                    <span v-if="scope.row.financeState==3">回款完成</span>
                    <span v-if="scope.row.financeState==4">已回款未开票</span>
                    <span v-if="scope.row.financeState==7">红冲</span>
                    <span v-if="scope.row.financeState==8">作废</span>
                    <span v-if="scope.row.financeState==5">其他</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="invoicingTime"
                label="开票时间"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="creatTime"
                label="创建时间"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="300px"
                align="center"
                >
                <template slot-scope="scope">
                    <!-- <el-button type="text" icon="el-icon-search" size="mini" @click="detail(scope.row)">详情</el-button>
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteDialog(scope.row)" v-if="roleName=='总管理员'">删除</el-button>
                    <el-button type="text" icon="el-icon-more" size="mini" @click="showRelevanceDialog(scope.row)" :style="scope.row.casesNumber==0?'color:red':''">关联案件</el-button>
                    <el-button type="text" icon="el-icon-s-grid" size="mini" @click="clearingDialog(scope.row)">清分</el-button> -->

                    <el-button type="text" icon="el-icon-search" size="mini" @click="detail(scope.row)">详情</el-button>
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)" v-if="isHandle=='1'">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteDialog(scope.row)" v-if="roleName=='总管理员'">删除</el-button>
                    <el-button type="text" icon="el-icon-more" size="mini" @click="showRelevanceDialog(scope.row)" :style="scope.row.relatedID?'':'color:red'">查看关联案件</el-button>
                    <el-button type="text" icon="el-icon-share" size="mini" @click="relevanceCaseDialog(scope.row)" v-if="isHandle=='1'">关联案件</el-button>
                    <el-button type="text" icon="el-icon-right" size="mini" @click="transfer(scope.row)" v-if="isHandle=='1'">转移立项</el-button>
                    
                    <el-button type="text" icon="el-icon-right" size="mini" @click="transferPerson(scope.row)" v-if="roleName=='总管理员'">转移人</el-button>
                    <el-button type="text" icon="el-icon-upload" size="mini" @click="pushKinDie(scope.row)" v-if="!scope.row.isPushKinDie&&isPush=='1'">复推</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next,sizes,total"
                    :total="totalCount"
                    :current-page="conditionData.pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>

        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="1200px">
            <div class="dialog dialog-a">
                <div class="item">
                    <div class="label">
                        <span>*</span>
                        立项类型:
                    </div>
                    <div class="item-input">
                        <el-select v-model="addData.carType" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in carTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <span>*</span>
                        立项名称:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addData.standTermName" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        上传缩略图:
                    </div>
                    <div class="item-input">
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="uploadimgUrl"
                            >
                            <el-button icon="el-icon-upload2" type="primary" size="small">点击上传</el-button>
                        </el-upload>
                        <div class="item-imgs">
                            <div style="width: 100px; height: 100px" class="item-img" v-for="(item,index) in imgUrlList" :key="index" v-if="item">
                                <div class="icon" @click="deleteImg(index)">
                                    <i class="el-icon-delete"></i>
                                </div>
                                <el-image
                                style="width: 100px; height: 100px"
                                :src="item"
                                :preview-src-list="[item]"
                                fit="cover"></el-image>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票号:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addData.invoiceNo" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票编码:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addData.invoiceCode" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addData.invoiceMoney" size="small" type="number" placeholder=""></el-input>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        实际收金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addData.netReceiptsMoney" size="small" type="number" placeholder=""></el-input>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        公司:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addData.company" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <span>*</span>
                        开票时间:
                    </div>
                    <div class="item-input">
                        <el-date-picker
                        v-model="addData.billingTime"
                        size="small"
                        type="datetime"
                        placeholder="选择日期时间">
                        </el-date-picker>
                        <!-- <el-input v-model="addData.billingTime" size="small" placeholder=""></el-input> -->
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        附件:
                    </div>
                    <div class="item-input">
                        <el-upload
                            :action="uploadUrl"
                            Multiple
                            :show-file-list="false"
                            :http-request="uploadFileUp"
                            >
                            <el-button icon="el-icon-upload2" type="primary" size="small">点击上传</el-button>
                        </el-upload>
                        <el-button icon="el-icon-download" type="primary" size="small" v-if="addData.fileUp" @click="download(addData.fileUp)" style="margin-left:10px">下载查看</el-button>
                    </div>
                </div>

                <!-- <div class="item">
                    <div class="label">
                        开票人:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addData.drawer" size="small" placeholder=""></el-input>
                    </div>
                </div> -->
                <!-- <div class="item">
                    <div class="label">
                        开票总金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addData.total" size="small" placeholder=""></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        <span>*</span>
                        委托公司全称:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addData.wholeCompanyName" size="small" placeholder=""></el-input>
                        <el-autocomplete
                            class="inline-input"
                            v-model="addData.wholeCompanyName"
                            :fetch-suggestions="querySearch"
                            placeholder=""
                            :trigger-on-focus="false"   
                            @select="handleSelect"
                            @keyup.enter.native="search"
                            size="small"
                        >
                            <template slot-scope="{ item }">
                                <div class="name">{{ item.subjectName}}</div>
                            </template>
                        </el-autocomplete>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        快递单号:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addData.expressOrderNumber" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        收件人:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addData.receivingPeople" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        联系电话:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addData.telephone" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        开票内容:
                    </div>
                    <div class="item-textarea" style="width:320px">
                        <el-input v-model="addData.billingContent" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item item-ta">
                    <div class="label">
                        备注:
                    </div>
                    <div class="item-textarea">
                        <el-input v-model="addData.remarks" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submit">确认提交</el-button>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="详情" :modal-append-to-body="true" width="1200px">
            <div class="dialog dialog-a">
                <div class="item">
                    <div class="label">
                        立项类型:
                    </div>
                    <div class="item-input">
                        <el-select v-model="detailData.carType" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in carTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        立项名称:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.standTermName" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        状态:
                    </div>
                    <div class="item-input">
                        <el-select v-model="detailData.state" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in carOutstandTermStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票号:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.invoiceNo" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票编码:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.invoiceCode" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.invoiceMoney" size="small" type="number" placeholder=""></el-input>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        实际收金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.netReceiptsMoney" size="small" type="number" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        上传缩略图:
                    </div>
                    <div class="item-input">
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="uploadimgUrl"
                            >
                            <el-button icon="el-icon-upload2" type="primary" size="small">点击上传</el-button>
                        </el-upload>
                        <div class="item-imgs">
                            <el-image
                            style="width: 100px; height: 100px"
                            :src="item"
                            v-for="(item,index) in imgUrlList"
                            :key="index"
                            :preview-src-list="[item]"
                            fit="cover"></el-image>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        公司:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.company" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        开票时间:
                    </div>
                    <div class="item-input">
                        <el-date-picker
                        v-model="detailData.billingTime"
                        type="datetime"
                        placeholder="选择日期时间">
                        </el-date-picker>
                        <!-- <el-input v-model="detailData.billingTime" size="small" placeholder=""></el-input> -->
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        附件:
                    </div>
                    <div class="item-input">
                        <el-upload
                            :action="uploadUrl"
                            Multiple
                            :show-file-list="false"
                            :http-request="uploadFileUp"
                            >
                            <el-button icon="el-icon-upload2" type="primary" size="small">点击上传</el-button>
                        </el-upload>
                        <el-button icon="el-icon-download" type="primary" size="small" v-if="detailData.fileUp" @click="download(detailData.fileUp)" style="margin-left:10px">下载查看</el-button>
                        
                    </div>
                </div>
                
                

                <!-- <div class="item">
                    <div class="label">
                        开票总金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.total" size="small" placeholder=""></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        委托公司全称:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.wholeCompanyName" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        快递单号:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.expressOrderNumber" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        收件人:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.receivingPeople" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        联系电话:
                    </div>
                    <div class="item-input">
                        <el-input v-model="detailData.telephone" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        开票内容:
                    </div>
                    <div class="item-textarea" style="width:320px">
                        <el-input v-model="detailData.billingContent" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>

                <div class="item item-ta">
                    <el-table
                    :data="remarksTable"
                    border
                    style="width:980px">
                        <el-table-column
                        prop=""
                        label="备注记录"
                        >
                        <template slot-scope="scope">
                            <span>{{scope.row}}</span>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isEditDialog" title="编辑" width="1200px">
            <div class="dialog dialog-a">
                <div class="item">
                    <div class="label">
                        立项类型:
                    </div>
                    <div class="item-input">
                        <el-select v-model="editData.carType" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in carTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        立项名称:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.standTermName" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        状态:
                    </div>
                    <div class="item-input">
                        <el-select v-model="editData.state" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in carOutstandTermStatus"
                            v-if="item.value"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        上传缩略图:
                    </div>
                    <div class="item-input">
                        <el-upload
                            :action="uploadUrl"
                            Multiple
                            :show-file-list="false"
                            :http-request="uploadimgUrlE"
                            >
                            <el-button icon="el-icon-upload2" type="primary" size="small">点击上传</el-button>
                        </el-upload>
                        <div class="item-imgs">
                            <div style="width: 100px; height: 100px" class="item-img" v-for="(item,index) in imgUrlList" :key="index" v-if="item">
                                <div class="icon" @click="deleteImg(index)">
                                    <i class="el-icon-delete"></i>
                                </div>
                                <el-image
                                style="width: 100px; height: 100px"
                                :src="item"
                                :preview-src-list="[item]"
                                fit="cover"></el-image>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票号:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.invoiceNo" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票编码:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.invoiceCode" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发票金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.invoiceMoney" size="small" type="number" placeholder=""></el-input>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        实际收金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.netReceiptsMoney" size="small" type="number" placeholder=""></el-input>
                    </div>
                </div>
                
                
                <div class="item">
                    <div class="label">
                        公司:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.company" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        开票时间:
                    </div>
                    <div class="item-input">
                        <el-date-picker
                        v-model="editData.billingTime"
                        type="datetime"
                        placeholder="选择日期时间">
                        </el-date-picker>
                        <!-- <el-input v-model="editData.billingTime" size="small" placeholder=""></el-input> -->
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        附件:
                    </div>
                    <div class="item-input">
                        <el-upload
                            :action="uploadUrl"
                            Multiple
                            :show-file-list="false"
                            :http-request="uploadFileUpE"
                            >
                            <el-button icon="el-icon-upload2" type="primary" size="small">点击上传</el-button>
                        </el-upload>
                        <!-- <el-image
                        style="width: 100px; height: 100px"
                        :src="editData.fileUp"
                         v-if="editData.fileUp"
                         :preview-src-list="[editData.fileUp]"
                        fit="cover"></el-image> -->
                        <el-button icon="el-icon-download" type="primary" size="small" v-if="editData.fileUp" @click="download(editData.fileUp)" style="margin-left:10px">下载查看</el-button>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        开票总金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.total" size="small" placeholder="" type="number"></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        委托公司全称:
                    </div>
                    <div class="item-input">
                        <el-autocomplete
                            class="inline-input"
                            v-model="editData.wholeCompanyName"
                            :fetch-suggestions="querySearch"
                            placeholder=""
                            :trigger-on-focus="false"   
                            @select="handleSelect"
                            @keyup.enter.native="search"
                            size="small"
                        >
                            <template slot-scope="{ item }">
                                <div class="name">{{ item.subjectName}}</div>
                            </template>
                        </el-autocomplete>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        快递单号:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.expressOrderNumber" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        收件人:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.receivingPeople" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        联系电话:
                    </div>
                    <div class="item-input">
                        <el-input v-model="editData.telephone" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        开票内容:
                    </div>
                    <div class="item-textarea" style="width:320px">
                        <el-input v-model="editData.billingContent" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item item-ta">
                    <div class="label">
                        备注:
                    </div>
                    <div class="item-textarea">
                        <el-input v-model="remarks" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <el-table
                    :data="remarksTable"
                    border
                    style="width: 510px">
                        <el-table-column
                        prop=""
                        label="备注记录"
                        >
                        <template slot-scope="scope">
                            <span>{{scope.row}}</span>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="edit">确认提交</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isRelevanceDialog" :title="relevanceTitle+'——关联案件'" width="1250px">
            <div class="condition">


                <div class="item">
                    <div class="label">综合查询:</div>
                    <el-input v-model="conditionCaseData.Multiple" size="small" placeholder="请输入"></el-input>
                </div>
            
                <div class="item">
                    <div class="label">开始日期:</div>
                    <el-date-picker
                    v-model="conditionCaseData.StartTime"
                    size="small"
                    type="date"
                    placeholder="选择日期">
                    </el-date-picker>
                </div>
                <div class="item">
                    <div class="label">结束日期:</div>
                    <el-date-picker
                    v-model="conditionCaseData.EndTime"
                    size="small"
                    type="date"
                    placeholder="选择日期">
                    </el-date-picker>
                </div>

                
                
                <div class="item">
                    <div class="label">财务状态:</div>
                    <el-select v-model="conditionCaseData.financeState" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in carOutstandTermStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                
                <div class="item">
                    <div class="label">是否已结算:</div>
                    <el-select v-model="conditionCaseData.IsEndCount" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in iSsettlementList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>



                <div class="btns">
                    <el-button type="primary" size="small" @click="selectCaseData()">查询</el-button>
                    <el-button type="" size="small" @click="resetCase()">重置</el-button>
                </div>
            </div>
            <div class="uploadbtn">
                <div class="l">
                    <el-tag type="success" style="margin-right:10px">公估费：{{caseCost}}</el-tag>
                    <el-tag>案件数：{{totalCountCase}}</el-tag>
                </div>
                <div class="r">
                    <el-button type="warning" icon="el-icon-warning" size="small" @click="cancelStandTermDialog" style="margin-bottom:10px" v-if="isHandle=='1'">取消所有关联案件</el-button>
                    <!-- <el-button type="success" icon="el-icon-download" size="small" @click="downloadExcel(1)" style="margin-bottom:10px">下载案件模板</el-button> -->
                    <el-button icon="el-icon-bottom" type="primary" size="small" style="margin-bottom:10px;margin-right:10px" @click="getExcel">导出excel</el-button>
                    <!-- <el-upload
                        :action="uploadUrl"
                        Multiple
                        :show-file-list="false"
                        :http-request="importInsurance"
                        >
                        <el-button icon="el-icon-upload" type="success" size="small" style="margin-bottom:10px;">导入excel</el-button>
                    </el-upload> -->
                </div>
                
            </div>
            <el-table
                :data="caseList"
                border
                :header-cell-style="tableHeaderColor"
                height="500px"
                style="width: 100%">
                
               <el-table-column
                prop="carOutsourceNo"
                label="案件ID"
                align="center"
                width="100"
                >
                </el-table-column>
                
                <el-table-column
                prop="month"
                label="所属派驻月份"
                align="center"
                width="180"
                >
                </el-table-column>
                <el-table-column
                prop="personnel"
                label="外包人员"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="expatriate"
                label="所属分公司"
                align="center"
                width="120"
                >
                </el-table-column>
                
                <el-table-column
                prop="sonCompany"
                label="地区"
                align="center"
                width="120"
                >
                </el-table-column>
               <el-table-column
                prop="underwriteInstitution"
                label="外派承保公司"
                align="center"
                width="200"
                
                >
                </el-table-column>
                <el-table-column
                prop="assessCost"
                label="标准公估费"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="actualCost"
                label="实际公估费"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="financeState"
                label="财务状态"
                align="center"
                width="120"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==6">未完成未开票</span>
                    <span v-if="scope.row.financeState==9">已完成未开票</span>
                    <span v-if="scope.row.financeState==1">已开票未回款</span>
                    <span v-if="scope.row.financeState==2">已开票部分回款</span>
                    <span v-if="scope.row.financeState==3">回款完成</span>
                    <span v-if="scope.row.financeState==4">已回款未开票</span>
                    <span v-if="scope.row.financeState==7">红冲</span>
                    <span v-if="scope.row.financeState==8">作废</span>
                    <span v-if="scope.row.financeState==5">其他</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="importTime"
                label="导入时间"
                align="center"
                width="180"
                >
                </el-table-column>
                
                <el-table-column
                prop="iSsettlement"
                label="是否结算"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.iSsettlement==0">未结算</span>
                    <span v-if="scope.row.iSsettlement==1">已结算</span>
                </template>
                </el-table-column>

                <el-table-column
                prop="standName"
                label="立项名称"
                align="center"
                width="150"
                >
                </el-table-column>
                
                <el-table-column
                prop="remarks"
                label="未决备注"
                align="center"
                width="300"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                prop=""
                label="操作"
                align="center"
                width="100"
                v-if="isHandle=='1'"
                >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="cancelCase(scope.row)">取消关联</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCaseCurrentChange"
                    background
                    layout="prev, pager, next,total"
                    :total="totalCountCase"
                    :current-page="conditionCaseData.pageIndex"
                    :page-size="conditionCaseData.pageSize">
                </el-pagination>
                
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isClearingDialog" title="清分列表" width="1250px">
            <div class="btn-list">
                <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addClearingDialog=true">新增清分公司</el-button>
            </div>
            <el-table
                :data="clearingList"
                border
                :header-cell-style="tableHeaderColor"
                height="500px"
                style="width: 100%">
                
               
                <el-table-column
                prop="companyName"
                label="公司名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="departmentName"
                label="部门名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="money"
                label="金额"
                align="center"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="240px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditClearingDialog(scope.row)">编辑</el-button>
                </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="addClearingDialog" title="添加清分分公司" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        公司:
                    </div>
                    <div class="item-input">
                        <el-select v-model="addClearingData.companyID" size="small" placeholder="请选择" @change="selectCompany">
                            <el-option
                            v-for="item in companyList"
                            :key="item.companyID"
                            :label="item.companyName"
                            :value="item.companyID">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        部门:
                    </div>
                    <div class="item-input">
                        <el-select v-model="addClearingData.departmentID" size="small" placeholder="请选择" @change="selectDepartment">
                            <el-option
                            v-for="item in departmentList"
                            :key="item.depID"
                            :label="item.depName"
                            :value="item.depID">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="addClearingData.money" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="addClearing">确认提交</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="updateClearingDialog" title="编辑清分分公司" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        公司:
                    </div>
                    <div class="item-input">
                        <el-select v-model="updateClearingData.companyID" size="small" placeholder="请选择" @change="selectCompany">
                            <el-option
                            v-for="item in companyList"
                            :key="item.companyID"
                            :label="item.companyName"
                            :value="item.companyID">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        部门:
                    </div>
                    <div class="item-input">
                        <el-select v-model="updateClearingData.departmentID" size="small" placeholder="请选择" @change="selectDepartment">
                            <el-option
                            v-for="item in departmentList"
                            :key="item.depID"
                            :label="item.depName"
                            :value="item.depID">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        金额:
                    </div>
                    <div class="item-input">
                        <el-input v-model="updateClearingData.money" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="updateClearing">确认提交</el-button>
                </div>
            </div>
        </el-dialog>
        


        <el-dialog :close-on-click-modal="false" :visible.sync="isRelevanceCaseDialog" :title="relevanceTitle+'——关联案件'" width="1200px">
            <div class="condition">
                <div class="item">
                    <div class="label">综合查询:</div>
                    <el-input v-model="conditionRelevanceData.Multiple" size="small" placeholder="请输入"></el-input>
                </div>
                

                <div class="item">
                    <div class="label">开始日期:</div>
                    <el-date-picker
                    v-model="conditionRelevanceData.StartTime"
                    size="small"
                    type="date"
                    placeholder="选择日期">
                    </el-date-picker>
                </div>
                <div class="item">
                    <div class="label">结束日期:</div>
                    <el-date-picker
                    v-model="conditionRelevanceData.EndTime"
                    size="small"
                    type="date"
                    placeholder="选择日期">
                    </el-date-picker>
                </div>

                
                <div class="item">
                    <div class="label">财务状态:</div>
                    <el-select v-model="conditionRelevanceData.financeState" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in financeStateList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
               



                
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectRelevanceData()">查询</el-button>
                    <el-button type="" size="small" @click="resetRelevance()">重置</el-button>
                </div>
            </div>
            <el-table
                :data="relevanceCaseList"
                border
                :header-cell-style="tableHeaderColor"
                height="500"
                style="width: 100%">
                <el-table-column
                prop="carOutsourceNo"
                label="案件ID"
                align="center"
                width="100"
                >
                </el-table-column>
                
                <el-table-column
                prop="month"
                label="所属派驻月份"
                align="center"
                width="180"
                >
                </el-table-column>
                <el-table-column
                prop="personnel"
                label="派驻人员"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="expatriate"
                label="所属分公司"
                align="center"
                width="120"
                >
                </el-table-column>
                
                <el-table-column
                prop="sonCompany"
                label="地区"
                align="center"
                width="120"
                >
                </el-table-column>
               <el-table-column
                prop="underwriteInstitution"
                label="派驻承保公司"
                align="center"
                width="200"
                
                >
                </el-table-column>
                <el-table-column
                prop="assessCost"
                label="标准公估费"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="actualCost"
                label="实际公估费"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="financeState"
                label="财务状态"
                align="center"
                width="120"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==6">未完成未开票</span>
                    <span v-if="scope.row.financeState==9">已完成未开票</span>
                    <span v-if="scope.row.financeState==1">已开票未回款</span>
                    <span v-if="scope.row.financeState==2">已开票部分回款</span>
                    <span v-if="scope.row.financeState==3">回款完成</span>
                    <span v-if="scope.row.financeState==4">已回款未开票</span>
                    <span v-if="scope.row.financeState==7">红冲</span>
                    <span v-if="scope.row.financeState==8">作废</span>
                    <span v-if="scope.row.financeState==5">其他</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="importTime"
                label="导入时间"
                align="center"
                width="180"
                >
                </el-table-column>
                
                <el-table-column
                prop="iSsettlement"
                label="是否结算"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.iSsettlement==0">未结算</span>
                    <span v-if="scope.row.iSsettlement==1">已结算</span>
                </template>
                </el-table-column>

                <el-table-column
                prop="standName"
                label="立项名称"
                align="center"
                width="150"
                >
                </el-table-column>
                
                <el-table-column
                prop="remarks"
                label="未决备注"
                align="center"
                width="300"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="100px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="selectAffirm(scope.row)">确认选择</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                @current-change="handleRelevanceCurrentChange"
                    background
                    layout="prev, pager, next,total"
                    :total="totalRelevanceCount"
                    :current-page="conditionRelevanceData.pageIndex"
                    :page-size="conditionRelevanceData.pageSize">
                </el-pagination>
                
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isRelevanceRemark" :title="'关联报案号：'+relevanceRemarkTitle" width="700px">
            <div class="dialog dialog-a">
                <div class="item ">
                    <div class="label">
                        实际金额:
                    </div>
                    <div class="item-textarea">
                        <el-input v-model="relevanceData.Price" type="number" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item ">
                    <div class="label">
                        备注:
                    </div>
                    <div class="item-textarea">
                        <el-input v-model="relevanceData.Remarks" type="textarea" :rows="4" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitRelevance">确认提交</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isTransferDialog" title="转移案件" width="700px">
            <div class="dialog dialog-a">
                <div class="item">
                    <div class="label">
                        转移模块:
                    </div>
                    <div class="item-input">
                        <el-select v-model="transferData.queryStand" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in moduleList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitTransfer">确认转移</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isTransferPersonDialog" title="转移人员" width="1000px">
            <div class="condition">
                <div class="item">
                    <div class="label">人员名称:</div>
                    <el-input v-model="conditionPersonData.Name" size="small" placeholder="请输入"></el-input>
                </div>
                
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectPerson()">查询</el-button>
                </div>
            </div>
            <el-table
                :data="personList"
                border
                :header-cell-style="tableHeaderColor"
                height="500"
                style="width: 100%">
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="userName"
                label="用户名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="roleName"
                label="用户类别"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="用户姓名"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="organization"
                label="所属机构"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="organization"
                label="账号状态"
                align="center"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="100px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="selectPersonAffirm(scope.row)">确认转移</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page" style="margin-top:20px">
                <el-pagination
                @current-change="handlePersonCurrentChange"
                    background
                    layout="prev, pager, next,total"
                    :total="personTotal"
                    :current-page="conditionPersonData.pageIndex"
                    :page-size="conditionPersonData.pageSize">
                </el-pagination>
                
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS,parseTimeD} from '../../../utils/index'
import {carOutstandTermStatus,carTypeList,companyTypeList,businessModuleList,moduleList} from '../../../assets/selectList/assetsSelectList'
import { provinceAndCityData , CodeToText } from "element-china-area-data";
export default {
    name: 'person',
    components:{
        
    },
    
    data () {
        return {
            time:"",
            caseTime:"",
            uploadUrl:'',
            provinceAndCityData:provinceAndCityData,
            carTypeList:carTypeList,
            district:'',
            title:'',
            isAddDialog:false,
            isDetailDialog:false,
            isEditDialog:false,
            isRelevanceDialog:false,
            totalCount:0,
            totalCountCase:0,
            caseCost:0,
            conditionData:localStorage.getItem('selectData')?JSON.parse(localStorage.getItem('selectData')):{
                Associated:null,
                Multiple:"",
                isLocalCase:null,
                StartTime:"",
                EndTime:"",
                pageIndex:1,
                pageSize:10,
            },
            conditionCaseData:{
                Multiple:"",
                CaseState:"",
                IsEndCount:null,
                StartTime:"",
                EndTime:null,
                pageIndex:1,
                pageSize:20,
            },
            tableData:[],
            detailData:{},
            addData:{
                netReceiptsMoney:0,
                invoiceMoney:0,
                invoiceCode:'',
                invoiceNo:'',
            },
            editData:{
                billingTime:'',
                company:'',
                fileUp:'',
                imgUrl:'',
                invoiceCode:'',
                invoiceMoney:0,
                invoiceNo:'',
                netReceiptsMoney:0,
                remarks:'',
                standProjectId:'',
                standTermName:'',
                type:'',
                total:null,
                wholeCompanyName:'',
                expressOrderNumber:'',
                receivingPeople:null,
                telephone:null,
                billingContent:'',
            },
            imgUrlList:[],
            caseList:[],
            standProjectId:'',
            carOutstandTermStatus:carOutstandTermStatus,
            lossStatusList:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'已指派未查勘',
                    value:1,
                },{
                    label:'已查勘待审核',
                    value:2,
                },{
                    label:'查勘已审核',
                    value:3,
                },{
                    label:'查勘退回',
                    value:5,
                },{
                    label:'品管已审核待转录',
                    value:6,
                },{
                    label:'已转录待保险公司审核',
                    value:7,
                },
            ],
            caseStatusList:[
                {
                    label:'全部',
                    value:null,
                },{
                    label:'案件未完成',
                    value:1,
                },{
                    label:'已核损待结案',
                    value:2,
                },{
                    label:'已结案',
                    value:3,
                }
            ],
            
            remarksTable:[],
            remarks:[],
            relevanceTitle:'',
            companyTypeList:companyTypeList,
            businessModuleList:businessModuleList,
            isClearingDialog:false,
            clearingList:[],
            addClearingDialog:false,
            addClearingData:{
                CompanyName:null,
                StandID:'',
                businessModule:1,
            },
            addClearingBusinessData:{
                accidentKey:null,
                assesAuse:null,
                fspa:null,
                jmkckp:null,
                kckp:null,
                sandID:null,
                statisticsID:null,
                tradition:null,
            },
            isShowEditClearingDialog:false,
            updateClearingDialog:false,
            updateClearingData:{
               companyID:'',
               companyName:'',
               departmentID:'',
               departmentName:'',
               id:'',
               money:'',
               standProjectId:''
            },
            companyList:[],
            departmentList:[],
            isAdmin:false,
            roleName:'',
            IsJoinCaseList:[
                {
                    label:'全部',
                    value:null,
                },{
                    label:'是',
                    value:true,
                },{
                    label:'否',
                    value:false,
                },
            ],
            iSsettlementList:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'未结算',
                    value:0,
                },{
                    label:'已结算',
                    value:1,
                },
            ],
            isYueList:[
                {
                    label:'否',
                    value:0,
                },{
                    label:'是',
                    value:1,
                },
            ],
            financeStateList:[{
                label:'已开票未回款',
                value:1,
            },{
                label:'已开票部分回款',
                value:2,
            },{
                label:'回款完成',
                value:3,
            },{
                label:'已收款未开票',
                value:4,
            },{
                label:'其他',
                value:5,
            }],
            selectIdList:[],

            isRelevanceCaseDialog:false,
            relevanceCaseList:[],
            conditionRelevanceData:{
                Multiple:"",
                StartTime:null,
                EndTime:null,
                IsEndCount:null,
                financeState:null,
                pageIndex:1,
                pageSize:20,
            },
            totalRelevanceCount:0,
            isRelevanceRemark:false,
            relevanceData:{
                StandID:'',
                Price:'',
                CaseID:'',
                Remarks:'',
            },
            relevanceRemarkTitle:'',


            isTransferDialog:false,
            moduleList:moduleList,
            transferData:{
                invoidceNo:'',
                queryStand:2,
            },
            invoiceNo:'',
            organizationList:[],
            isHandle:localStorage.getItem('isHandle'),
            isPush:localStorage.getItem('isPush'),


            transferPersonData:{
                invoidceNo:'',
                project:'',
            },
            isTransferPersonDialog:false,
            conditionPersonData:{
                Name:'',
                disable:2,
                pageIndex:1,
                pageSize:10,
            },
            personList:[],
            personTotal:0,
        }
    },
    watch:{
        $route(to,from){
            if((from.name == 'carOutsourceSettlementProjectDetail') && to.name == 'carOutsuranceSettlementProject'){
                this.loadingData();
            }
        }
    },
    created(){
        

    },

    mounted(){
        this.isAdmin = localStorage.getItem("userName")=='admin'?true:false;
        this.roleName = localStorage.getItem("roleName")
        console.log(this.carOutstandTermStatus);
        this.loadingData();
        this.getCompanyList();
        this.getRelevanceCaseList();
        this.statisticsGetCompany();
        this.getPersonList();
    },
    methods:{
        handlePersonCurrentChange(page){
            this.conditionPersonData.pageIndex = page;
            this.getPersonList();
        },
        transferPerson(row){
            this.isTransferPersonDialog = true;
            this.transferPersonData.invoidceNo = row.invoiceNo;
        },
        selectPerson(){
            this.conditionPersonData.pageIndex = 1;
            this.getPersonList();
        },
        async selectPersonAffirm(row){
            this.transferPersonData.project = row.userName
            let res = await api.divertStandProject(this.transferPersonData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '转移成功!'
                });
                this.loadingData();
                this.isTransferPersonDialog = false;
            }
        },
        async getPersonList(){
            let res  = await api.queryAllUser(this.conditionPersonData);
            this.personList = res.data.data.entitys;
            this.personTotal = res.data.data.pageLen;
        },


        async pushKinDie(row){
            let res = await api.pushKinDie({invoiceNo:row.invoiceNo});
            if(res.data.data.data){
                this.$message({
                    type: 'success',
                    message: '复推成功!'
                });
                this.loadingData();
            }else{
                if(!res.data.data){
                    return;
                }
                this.$confirm(res.data.data.msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                }).catch(() => {
                });
            }
        },
        async statisticsGetCompany(){
            let res = await api.statisticsGetCompany();
            this.organizationList = res.data.data
        },
        transfer(row){
            this.isTransferDialog = true;
            this.transferData.invoidceNo = row.invoiceNo;
        },
        async submitTransfer(){
            let res = await api.diverStand(this.transferData);
            if(res.data.code == '200'){
                this.loadingData();
                this.isTransferDialog = false;
            }
        },
        // 关联案件
        relevanceCaseDialog(row){
            this.invoiceNo = row.invoiceNo;
            this.isRelevanceCaseDialog = true;
            this.relevanceData.StandID = row.standProjectId+'';
            this.relevanceTitle = row.name;
            
        },
        // 确认选择
        selectAffirm(row){
            console.log(row);
            this.isRelevanceRemark = true;
            this.relevanceData.Remarks = row.outRemarks?row.outRemarks:this.invoiceNo;
            this.relevanceData.Price = row.actualCost;
            this.relevanceData.CaseID = row.carOutsourceNo+'';
            this.relevanceRemarkTitle = row.carOutsourceNo;
        },
        // 确认选择提交
        async submitRelevance(){
            this.relevanceData.Price = parseFloat(this.relevanceData.Price);
            let res = await api.singleAssociationCarOutsurance(this.relevanceData);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '提交成功!'
                });
                this.isRelevanceRemark = false;
                this.isRelevanceCaseDialog = false;
                this.conditionRelevanceData = {
                    Multiple:"",
                    StartTime:"",
                    EndTime:"",
                    CaseTyep:null,
                    Category:null,
                    Company:"",
                    ISSettlement:null,
                    pageIndex:1,
                    pageSize:20,
                }
                this.getRelevanceCaseList();
                this.loadingData();
            }
        },
        // 查询
        selectRelevanceData(){
            this.conditionRelevanceData.pageIndex = 1;
            this.getRelevanceCaseList();
        },
        resetRelevance(){
            this.conditionRelevanceData = {
                Multiple:"",
                StartTime:"",
                EndTime:"",
                CaseTyep:null,
                Category:null,
                Company:"",
                ISSettlement:null,
                pageIndex:1,
                pageSize:20,
            },
            this.getRelevanceCaseList();
        },
        async handleRelevanceCurrentChange(pageIndex){
            this.conditionRelevanceData.pageIndex = pageIndex;
            this.getRelevanceCaseList();
        },
        // 案件列表
        async getRelevanceCaseList(){
            let res  = await api.carOutsourceGetPagedList(this.conditionRelevanceData);
            console.log(res);
            this.relevanceCaseList = res.data.data.entitys;
            this.totalRelevanceCount = res.data.data.pageLen;
            for(let i in this.relevanceCaseList){
                this.relevanceCaseList[i].dispatchingTime = parseTimeD(this.relevanceCaseList[i].dispatchingTime)
                this.relevanceCaseList[i].caseEndTime = parseTimeD(this.relevanceCaseList[i].caseEndTime)
            }
        },



        // 列表选择
        handleSelectionChange(list){
            this.selectIdList = list;
            console.log(list);
        },
        // 立项关联案件
        async showRelevanceUpload(file){
            if(this.selectIdList.length==0){
                this.$message({
                    type: 'warning',
                    message: '请选择立项!'
                });
                return;
            }
            let standProjectIdList = '';
            for(let index in this.selectIdList){
                if(index==0){
                    standProjectIdList = this.selectIdList[index].standProjectId
                }else{
                    standProjectIdList = standProjectIdList+','+this.selectIdList[index].standProjectId
                }
            }
            console.log(standProjectIdList);
            console.log(localStorage.getItem("userName"));
            let res = await api.carOutsourceRelatedStand(file.file,{
                userName:localStorage.getItem("userName"),
                StandProjectId:standProjectIdList,
            });
        
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '关联成功'
                });
                this.loadingData();
            }
        },
        async getCaseList(row){
            if(this.caseTime){
                this.conditionCaseData.StartTime = parseTimeD(this.caseTime[0]);
                this.conditionCaseData.EndTime = parseTimeD(this.caseTime[1]);
            }
            this.conditionCaseData.StandID = row?row.standProjectId:this.standProjectId;


            //this.conditionCaseData.RelatedID =  this.conditionCaseData.RelatedID;
            let res = await api.carOutsourceGetPagedList(this.conditionCaseData);
            console.log(res);
            this.caseList = res.data.data.entitys;
            this.totalCountCase = res.data.data.pageLen;
            this.caseCost = res.data.data.cost;
            if(res.data.code == 200){
                this.isRelevanceDialog = true;
            }
            for(let i in this.caseList){
                this.caseList[i].commissionTime = parseTimeS(this.caseList[i].commissionTime)
                this.caseList[i].statusTime = parseTimeS(this.caseList[i].statusTime)
            }
            
        },
        async submit(){
            this.addData.state = 1;
            this.addData.drawer = localStorage.getItem("userName");
            this.addData.fileUp = this.addData.fileUp?this.addData.fileUp:'';
            if(this.addData.invoiceMoney){
                this.addData.invoiceMoney = parseFloat(this.addData.invoiceMoney);
            }else{
                this.addData.invoiceMoney = 0;
            }
            if(this.addData.netReceiptsMoney){
                this.addData.netReceiptsMoney = parseFloat(this.addData.netReceiptsMoney);
            }else{
                this.addData.netReceiptsMoney = 0;
            }
            if(this.addData.total){
                this.addData.total = parseFloat(this.addData.total);
            }else{
                this.addData.total = 0;
            }
            // this.addData.billingTime = parseTimeS(this.addData.billingTime);
            this.addData.imgUrl=''
            for(let index in this.imgUrlList){
                if(index==0){
                    this.addData.imgUrl = this.imgUrlList[index]
                }else{
                    this.addData.imgUrl = this.addData.imgUrl+','+this.imgUrlList[index]
                }
            }
            let res = await api.carOutsourceInsertStand(this.addData);
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '插入成功!'
                });
                this.isAddDialog = false;
                this.addData = {
                    netReceiptsMoney:0,
                    invoiceMoney:0,
                }
                this.loadingData();
            }
            
        },
        async uploadFileUp(file){
            let res = await api.uploadOther(file.file);
            console.log(res);
            this.addData.fileUp = res;
            this.$forceUpdate();
        },
        async uploadimgUrl(file){
            let res= await api.invoiceImg(file.file,{
                IsReturn:false
            });
            if(res.data.code == '200'){
                this.addData.invoiceCode = res.data.data.invoiceCode;
                this.addData.invoiceNo = res.data.data.invoiceNo;
                this.addData.company = res.data.data.purchaserName;

                let resOss = await api.uploadOther(file.file);
                console.log(resOss);
                this.imgUrlList.push(resOss);
                this.$forceUpdate();
            }
        },
        async uploadFileUpE(file){
            let res = await api.uploadOther(file.file);
            console.log(res);
            this.editData.fileUp = res;
            this.$forceUpdate();
        },
        async uploadimgUrlE(file){
            let res= await api.invoiceImg(file.file,{
                IsReturn:false
            });
            if(res.data.code == '200'){
                this.editData.invoiceCode = res.data.data.invoiceCode;
                this.editData.invoiceNo = res.data.data.invoiceNo;
                this.editData.company = res.data.data.purchaserName;

                let resOss = await api.uploadOther(file.file);
                this.imgUrlList.push(resOss);
                this.$forceUpdate();
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            if(this.time){
                this.conditionData.StartTime = parseTimeD(this.time[0]);
                this.conditionData.EndTime = parseTimeD(this.time[1]);
            }
            let res  = await api.carOutsourceGetStandList(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.entitys;
            this.totalCount = res.data.data.pageLen;
            for(let i in this.tableData){
                this.tableData[i].billingTimeStr = parseTimeD(this.tableData[i].billingTime)
            }
        },
        selectData(){
            this.conditionData.pageIndex = 1;
            this.loadingData();
        },
        selectCaseData(){
            this.conditionCaseData.pageIndex = 1;
            console.log(this.conditionCaseData);
            this.getCaseList();
        },
        reset(){
            this.time = '';
            this.conditionData = {
                Associated:null,
                Multiple:"",
                isLocalCase:null,
                StartTime:"",
                EndTime:"",
                pageIndex:1,
                pageSize:10,
            },
            this.loadingData();
        },
        resetCase(){
            this.caseTime = '';
            // this.conditionCaseData = {
            //     Multiple:"",
            //     CaseState:"",
            //     IsEndCount:null,
            //     StartTime:"",
            //     EndTime:null,
            //     pageIndex:1,
            //     pageSize:20,
            // },
            this.conditionCaseData.Multiple="";
            this.conditionCaseData.CaseState="";
            this.conditionCaseData.IsEndCount=null;
            this.conditionCaseData.StartTime=null;
            this.conditionCaseData.EndTime=null;

            this.getCaseList();
        },
        handleCurrentChange(pageIndex){
            this.conditionData.pageIndex = pageIndex;
            this.loadingData();
        },
        handleSizeChange(pageSize){
            this.conditionData.pageIndex = 1;
            this.conditionData.pageSize = pageSize;
            this.loadingData();
        },
        handleCaseCurrentChange(pageIndex){
            this.conditionCaseData.pageIndex = pageIndex;
            this.getCaseList()
        },
        detail(row){
            localStorage.setItem('selectData',JSON.stringify(this.conditionData))
            this.editData.standProjectId = row.standProjectId;
            this.editData.standType = row.standType;
            this.editData.name = row.name;
            this.editData.invoiceNo = row.invoiceNo;
            this.editData.imgUrl = row.imgUrl;
            if(row.imgUrl){
                this.imgUrlList = row.imgUrl.split(',');
            }else{
                this.imgUrlList = [];
            }
            this.editData.invoiceCode = row.invoiceCode;
            this.editData.invoicePrice = row.invoicePrice;
            this.editData.invoiceNo = row.invoiceNo;
            this.editData.invoicingTime = row.invoicingTime;
            
            this.editData.actualPrice = row.actualPrice;
            if(row.remarks){
                this.remarksTable = row.remarks.split('<remarksTable>');
            }else{
                this.remarksTable = [];
            }
            this.editData.relatedID = row.relatedID;
            this.editData.standTermName = row.standTermName;
            this.editData.type = row.type;
            this.editData.standType = row.standType;
            this.editData.total = row.total;
            this.editData.companyCodeName = row.companyCodeName;
            this.editData.company = row.company;
            this.editData.expressOrderNumber = row.expressOrderNumber;
            this.editData.receivingPeople = row.receivingPeople;
            this.editData.telephone = row.telephone;
            this.editData.sellerName = row.sellerName;
            this.editData.organization = row.organization;
            this.editData.billingContent = row.billingContent;
            
            this.editData.projectPeople = localStorage.getItem("userName");
            localStorage.setItem('editData',JSON.stringify(row));
            this.$router.push({
                name:'carOutsourceSettlementProjectDetail',
                query:{
                    id:row.standProjectId,
                    invoiceNo:this.editData.invoiceNo,
                    isDetail:true,
                }
            })
        },
        showEditDialog(row){
            localStorage.setItem('selectData',JSON.stringify(this.conditionData))
            this.editData.standProjectId = row.standProjectId;
            this.editData.standType = row.standType;
            this.editData.name = row.name;
            this.editData.invoiceNo = row.invoiceNo;
            this.editData.imgUrl = row.imgUrl;
            if(row.imgUrl){
                this.imgUrlList = row.imgUrl.split(',');
            }else{
                this.imgUrlList = [];
            }
            this.editData.invoiceCode = row.invoiceCode;
            this.editData.invoicePrice = row.invoicePrice;
            this.editData.invoiceNo = row.invoiceNo;
            this.editData.invoicingTime = row.invoicingTime;
            
            this.editData.actualPrice = row.actualPrice;
            // this.editData.remarks = row.remarks;
            if(row.remarks){
                this.remarksTable = row.remarks.split('<remarksTable>');
            }else{
                this.remarksTable = [];
            }
            this.editData.relatedID = row.relatedID;
            this.editData.standTermName = row.standTermName;
            this.editData.type = row.type;
            this.editData.standType = row.standType;
            this.editData.total = row.total;
            this.editData.companyCodeName = row.companyCodeName;
            this.editData.company = row.company;
            this.editData.expressOrderNumber = row.expressOrderNumber;
            this.editData.receivingPeople = row.receivingPeople;
            this.editData.telephone = row.telephone;
            this.editData.sellerName = row.sellerName;
            this.editData.organization = row.organization;
            this.editData.billingContent = row.billingContent;
            
            this.editData.projectPeople = localStorage.getItem("userName");
            localStorage.setItem('editData',JSON.stringify(row));
            this.$router.push({
                name:'carOutsourceSettlementProjectDetail',
                query:{
                    invoiceNo:this.editData.invoiceNo,
                    id:row.standProjectId
                }
            })
        },
        showAddDialog(){
            this.$router.push({
                name:'carOutsourceSettlementProjectDetail'
            })
        },
        showRelevanceDialog(row){
            this.relevanceTitle = row.name;
            this.standProjectId = row.standProjectId;
            this.relatedID = row.relatedID?row.relatedID:-1;
            this.conditionCaseData.RelatedID = row.relatedID?row.relatedID:-1;
            this.getCaseList(row);
        },
        async edit(){
            if(this.editData.invoiceMoney){
                this.editData.invoiceMoney = parseFloat(this.editData.invoiceMoney);
            }else{
                this.editData.invoiceMoney = 0;
            }
            if(this.editData.netReceiptsMoney){
                this.editData.netReceiptsMoney = parseFloat(this.editData.netReceiptsMoney);
            }else{
                this.editData.netReceiptsMoney = 0;
            }
            if(this.editData.total){
                this.editData.total = parseFloat(this.editData.total);
            }else{
                this.editData.total = 0;
            }
            this.editData.imgUrl=''
            for(let index in this.imgUrlList){
                if(index==0){
                    this.editData.imgUrl = this.imgUrlList[index]
                }else{
                    this.editData.imgUrl = this.editData.imgUrl+','+this.imgUrlList[index]
                }
            }
            for(let index in this.remarksTable){
                if(index==0){
                    this.editData.remarks = this.remarksTable[index]
                }else{
                    this.editData.remarks = this.editData.remarks + '<remarksTable>' + this.remarksTable[index]
                }
            }
            if(this.remarks&&this.remarks.length>0){
                if(this.editData.remarks){
                    this.editData.remarks = this.editData.remarks + '<remarksTable>' + this.remarks
                }else{
                    this.editData.remarks = this.remarks
                }
            }
            let res = await api.carOutsourceUpdataStand(this.editData);
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
                this.isEditDialog = false;
                this.remarks = '';
                this.loadingData();
            }
        },
        // 导入
        async importInsurance(file){
            console.log(file);
            console.log(this.standProjectId);
            let res = await api.carOutsourceImport(file.file,{
                StandID:this.standProjectId,
                userName:localStorage.getItem("userName")
            });
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '导入成功!'
                });
                this.getCaseList({standProjectId:this.standProjectId});
            }
        },
        // 批量新增
        async addBatch(file){
            console.log(file);
            console.log(this.standProjectId);
            let res = await api.carOutsourceAddsSandProject(file.file,{
                userName:localStorage.getItem("userName")
            });
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '导入成功!'
                });
                this.loadingData();
            }
        },
        // 下载
        download(url){
            this.$message({
                type: 'success',
                message: '正在下载，请稍等!'
            })
            const elt = document.createElement('a');
            elt.setAttribute('href', url);
            // elt.setAttribute('download', 'file.png');
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        downloadExcel(type){
            this.$message({
                type: 'success',
                message: '正在下载，请稍等!'
            })
            const elt = document.createElement('a');
            if(type == 1){
                elt.setAttribute('href', 'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210826/20210826170211cFBF5');
			    elt.setAttribute('download', '案件模板');
            }else if(type == 2){
                // elt.setAttribute('href', 'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20211118/20211118103053BNNti');
                elt.setAttribute('href', 'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20220816/20220816183432ye86X');
			    elt.setAttribute('download', '立项模板');
            }
            else if(type == 3){
                elt.setAttribute('href', 'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20220816/20220816183432ye86X');
			    elt.setAttribute('download', '立项批量编辑模板');
            }
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        async getExcel(){
            let option = {
            }
            if(this.conditionCaseData.RelatedID){
                option.RelatedID = this.conditionCaseData.RelatedID;
            }
            if(this.conditionCaseData.Multiple){
                option.Multiple = this.conditionCaseData.Multiple;
            }
            if(this.conditionCaseData.CaseState){
                option.CaseState = this.conditionCaseData.CaseState;
            }
            if(this.conditionCaseData.IsEndCount){
                option.IsEndCount = this.conditionCaseData.IsEndCount;
            }
            if(this.conditionCaseData.StartTime){
                option.StartTime = this.conditionCaseData.StartTime;
            }
            if(this.conditionCaseData.EndTime){
                option.EndTime = this.conditionCaseData.EndTime;
            }
            let res = await api.carOutsourceExport(option);
        },
        async downloadList(){
            let option = {};
            if(this.conditionData.Multiple){
                option.Multiple = this.conditionData.Multiple;
            }
            if(this.conditionData.isLocalCase){
                option.ISLocalCase = this.conditionData.isLocalCase;
            }
            if(this.conditionData.StartTime){
                option.StartTime = this.conditionData.StartTime;
            }
            if(this.conditionData.EndTime){
                option.EndTime = this.conditionData.EndTime;
            }
            if(this.conditionData.Associated){
                option.Associated = this.conditionData.Associated;
            }
            if(this.conditionData.Organization){
                option.Organization = this.conditionData.Organization;
            }
            if(this.conditionData.IsJoinCase!=null){
                option.IsJoinCase = this.conditionData.IsJoinCase;
            }
           
            let res = await api.carOutsourceStandExport(option);
        },
        // 删除
        deleteImg(index){
            this.imgUrlList.splice(index,1);
        },
        // 批量修改
        async UpdateBatch(file){
            let res = await api.carOutsourceUpSandProject(file.file,{
                userName:localStorage.getItem("userName")
            });
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                this.loadingData();
            }
        },
        deleteDialog(row){
            this.$confirm('是否删除当前选定的立项?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteProject(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async deleteProject(row){
            let res = await api.deleteProjectCarOutsource(row.standProjectId);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        // 
        cancelStandTermDialog(){
            this.$confirm('是否取消关联所有案件?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.cancelStandTerm();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async cancelStandTerm(){
            let res = await api.cancelCarOutsource({
                standProjectId:JSON.stringify(this.standProjectId),
                operator:localStorage.getItem("userName"),
            });
            
            if(res.data.code == '200') {
                this.$message({
                    message: '取消关联所有案件成功',
                    type: 'success'
                });
                this.getCaseList();
            }
        },
        async clearingDialog(row){
            this.isClearingDialog = true;
            this.addClearingData = {
                companyID: null,
                companyName: "",
                departmentID: null,
                departmentName: "",
                standProjectId: JSON.stringify(row.standProjectId),
                money: 0
            };
            let res = await api.externalQueryByStandID({
                StandID:row.standProjectId,
            });
            if(res.data.data.length==0){
                this.clearingList = [];
                
            }else{
                this.clearingList = res.data.data;
            }
        },
        async addClearing(){
            this.addClearingData.money = parseFloat(this.addClearingData.money);
            let res = await api.addClearing(this.addClearingData);
            if(res.data.code == '200'){
                this.addClearingDialog = false;
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                });
                let res2 = await api.externalQueryByStandID({
                    StandID:this.addClearingData.standProjectId,
                });
                if(res2.data.data.length==0){
                    this.clearingList = [];
                    
                }else{
                    this.clearingList = res2.data.data;
                }
            }
        },
        async showEditClearingDialog(row){
            console.log(row);
            this.updateClearingData.companyID = row.companyID;
            this.updateClearingData.companyName = row.companyName;
            this.updateClearingData.departmentID = row.departmentID;
            this.updateClearingData.departmentName = row.departmentName;
            this.updateClearingData.id = row.id;
            this.updateClearingData.money = row.money;
            this.updateClearingData.standProjectId = row.standProjectId;
            this.getDepartmentList(row.companyID);
            this.updateClearingDialog = true;
        },
        async updateClearing(){
            this.updateClearingData.money = parseFloat(this.updateClearingData.money);
            let res = await api.updateClearing(this.updateClearingData);
            if(res.data.code==200){
                this.$message({
                    type: 'success',
                    message: '编辑成功!',
                });
                this.updateClearingDialog = false;
                this.clearingDialog({standProjectId:this.updateClearingData.standProjectId})
            }
        },
        async getCompanyList(){
            let res  = await api.queryAllCompany(this.conditionData);
            this.companyList = res.data.data;
            console.log(this.companyList);
        },
        async getDepartmentList(id){
            
            let res  = await api.queryDepartment({
                compID:id,
            });
            this.departmentList = res.data.data;
            console.log(this.departmentList);
        },
        async selectCompany(item){
            for(let index in this.companyList){
                if(this.companyList[index].companyID == item){
                    this.addClearingData.companyName = this.companyList[index].companyName;
                    this.getDepartmentList(item);
                    return;
                }
            }
        },
        async selectDepartment(item){
            console.log(item);
            for(let index in this.departmentList){
                if(this.departmentList[index].depID == item){
                    this.addClearingData.departmentName = this.departmentList[index].depName;
                    return;
                }
            }
        },
        
        async cancelCase(row){
            this.$confirm('将取消关联，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.cancelCaseFun(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async cancelCaseFun(row){
            console.log(row);
            let res = await api.cancelCarOutsource({
                doubtTaskId:JSON.stringify(row.carOutsourceNo),
                operator:localStorage.getItem("userName"),
            });
            if(res.data.code==200){
                this.$message({
                    type: 'success',
                    message: '取消关联成功!',
                });
                this.getCaseList();

                // this.clearingDialog({standProjectId:this.updateClearingData.standProjectId})

            }
        },

        async querySearch(queryString, cb){
            let res = await api.qeryMechanismsBYName({name:queryString}); 
            let list = res.data.data;
            console.log(queryString);
            let results = queryString ? list.filter(this.createFilter(queryString)) : list;
            console.log(results);
            cb(results);
        },
        handleSelect(e){
            console.log(e);
            if(this.isEditDialog){
                this.editData.wholeCompanyName = e.subjectName;
            }
            else if(this.isAddDialog){
                this.addData.wholeCompanyName = e.subjectName;
            }
        },
        createFilter(queryString) {
            return (list) => {
                return (list.subjectName.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
            };
        },
    }
    
}
</script>

<style lang="scss" scoped>
    // /deep/.el-dialog__wrapper{
    //     z-index: 101 !important;
    // }
    /deep/.el-image-viewer__wrapper{
        z-index: 9999 !important;
    }
    .push{
        /deep/.el-button--text{
        }
        /deep/.el-button--danger{
            color: #FF0000;
            border:1px solid #FF0000;
            background-color: #ffffff;
        }
        /deep/.el-button--mini{
            padding: 7px 7px;
            padding-right: 10px;
            margin-left: 4px;
        }
    }
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 8px 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 7px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .btn-list{
        display: flex;
        padding-bottom: 15px;
    }
    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        
        .item{
            
            font-size: 14px;
            padding:10px 150px;
            display: flex;
            align-items: center;
            justify-content: center;
            .label{
                min-width: 110px;
                margin-bottom: 5px;
                span{
                    color:red
                }
            }
            .item-input{
                width: 340px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                /deep/.el-input{
                    width: 320px;
                }
            }
            .item-imgs{
                width: 400px;
                display: flex;
                flex-wrap: wrap;
                margin-top: 10px;
                .item-img{
                    position: relative;
                    margin-right: 10px;
                    margin-bottom: 10px;
                    .icon{
                        right: 0;
                        top: 0;
                        position:absolute;
                        z-index: 100;
                        color: #ffffff;
                        background-color: #000000;
                        width: 18px;
                        height: 18px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }

                }
            }
            /deep/.el-image{
                margin-right: 10px;
                margin-bottom: 10px;
            }
            .item-textarea{
                width: 400px;
            }
        }
        
        .dialog-footer{
            width: 100%;
            display: flex;
            justify-content: center;
            .el-button{
                margin-top: 20px;
            }
        }
        
    }
    .dialog-a{
        .item{
            font-size: 14px;
            padding:10px 50px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .item-ta{
            width: 980px;
            .item-textarea{
                width: 960px;
            }
        }
        
    }
    .uploadbtn{
        width: 100%;
        display: flex;
        justify-content: space-between;
        .r{
            display: flex;
        }
    }
</style>
